module.exports = __webpack_public_path__ + "assets/img/60.3d4e0a63.svg";